import { BTInput } from "@btnet/core-components";

import { BdsIconMagnifyingGlass, BdsIconXCircle } from "@buildertrend/components";

import { handleEnterKeyPressed } from "utilities/form/form";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";

import "./JobSearchInput.less";

interface IJobSearchInputProps {
    // The keyword committed via a filter submit (empty string means no active search).
    // Controls the readonly lock and whether clearing should trigger a refresh.
    committedKeyword: string;
    // The user's in-progress local text.
    localKeyword: string;
    setLocalKeyword: (value: string) => void;
    onKeywordClear: () => Promise<void>;
}

export function JobSearchInput({
    committedKeyword,
    localKeyword,
    setLocalKeyword,
    onKeywordClear,
}: IJobSearchInputProps) {
    const isCommitted = committedKeyword !== "";
    return (
        <BTInput
            id="JobSearch"
            className="JobSearch"
            suffix={
                localKeyword === "" ? (
                    <BdsIconMagnifyingGlass />
                ) : (
                    <BTButton
                        data-testid="clear-search"
                        className="JobSearch-Clear"
                        type="tertiary"
                        icon={<BdsIconXCircle />}
                        onClick={async () => {
                            setLocalKeyword("");
                            if (isCommitted) {
                                await onKeywordClear();
                            }
                        }}
                    />
                )
            }
            placeholder="Search"
            data-testid="JobSearch"
            value={localKeyword}
            // Disable form submit on enter. Otherwise it opens the clock-in/clock-out dialog
            onKeyDown={(e) => handleEnterKeyPressed(e, () => {})}
            onChange={async (_field, value) => {
                setLocalKeyword(value);
                if (isCommitted && value === "") {
                    await onKeywordClear();
                }
            }}
        />
    );
}
